export const LH_EXPRESS_ROUTE_FOR_FILTER = {
  origin: 'LH ES',
  destination: 'LH ES',
  country: 'ES',
  display_name: 'LH ES',
  enabled: true,
  local: true,
  defined: true,
  name: 'LH ES',
  isInternational: false,
  simple_name: 'LH ES',
  symmetric_name: 'LH ES',
  enabled_corridor: false,
};

export const LH_EXPRESS_FR_ROUTE_FOR_FILTER = {
  origin: 'LH FR',
  destination: 'LH FR',
  country: 'FR',
  display_name: 'LH FR',
  enabled: true,
  local: true,
  defined: true,
  name: 'LH FR',
  isInternational: false,
  simple_name: 'LH FR',
  symmetric_name: 'LH FR',
  enabled_corridor: false,
};
